import { useEffect, useState } from 'react';

const useCountdown = (targetDate: number) => {
  const countDownDate = new Date(targetDate).getTime();

  const [countDown, setCountDown] = useState(
    countDownDate - new Date().getTime(),
  );

  useEffect(() => {
    if (countDown > 0) {
      const interval = setInterval(() => {
        setCountDown(countDownDate - new Date().getTime());
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [countDown, countDownDate]);

  return getReturnValues(countDown);
};

const getReturnValues = (countDown: number) => {
  let hours = 0;
  let minutes = 0;
  let seconds = 0;

  // calculate time left
  if (countDown > 0) {
    hours = Math.floor((countDown % (1000 * 60 * 60 * 60)) / (1000 * 60 * 60));
    minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60));
    seconds = Math.floor((countDown % (1000 * 60)) / 1000);
  }

  return [hours, minutes, seconds];
};

export { useCountdown };
